module.exports = __webpack_public_path__ + "img/flipkartWeavr.15046fb1.svg";